import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Typography, Alert } from "@mui/material";
import { VERTICALS, VERTICAL_ORDER } from "../verticals";
import { usePlatformSiteCatalog } from "../usePlatformSiteCatalog";
/**
 * Structural placeholder -- there's no written product documentation yet, so this lists what
 * exists (each product, grouped by vertical) rather than fabricating docs content. Fill in real
 * per-product guides as they're written.
 */
export default function DocsPage() {
    const { sites: PLATFORM_SITES } = usePlatformSiteCatalog();
    return (_jsxs(Box, { sx: { maxWidth: 760, mx: "auto", px: 3, py: 8 }, children: [_jsx(Typography, { variant: "h3", fontWeight: 800, sx: { mb: 3 }, children: "Docs" }), _jsx(Alert, { severity: "info", sx: { mb: 4 }, children: "Written guides aren't published yet. This page is a placeholder index of what exists \u2014 each product's own docs will be linked here as they're written." }), VERTICAL_ORDER.map((vertical) => {
                const meta = VERTICALS[vertical];
                const sites = PLATFORM_SITES.filter((s) => s.vertical === vertical);
                if (sites.length === 0)
                    return null;
                return (_jsxs(Box, { sx: { mb: 4 }, children: [_jsx(Typography, { variant: "h6", fontWeight: 700, sx: { color: meta.accentColor, mb: 1 }, children: meta.label }), sites.map((site) => (_jsxs(Box, { sx: { mb: 1.5 }, children: [_jsx(Typography, { fontWeight: 700, children: site.label }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: "Docs coming soon." })] }, site.slug)))] }, vertical));
            })] }));
}
